import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock, Download } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { CountdownTimer } from '../ui/CountdownTimer';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-bg-primary relative overflow-hidden" data-id="element-179">
      {/* Background effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[600px] bg-cta-primary/5 blur-[120px] rounded-full pointer-events-none" data-id="element-180" />

      <div className="container max-w-lg mx-auto relative z-10" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-card border-2 border-cta-primary rounded-3xl p-8 md:p-10 shadow-[0_0_50px_rgba(34,197,94,0.1)]" data-id="element-182">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-183">
            <h2 className="text-2xl font-bold text-text-primary mb-4" data-id="element-184">
              Acceso Inmediato
            </h2>

            {/* Price Comparison */}
            <div className="mb-4" data-id="element-185">
              <p className="text-text-secondary text-sm mb-2" data-id="element-186">Valor Regular:</p>
              <p className="text-2xl md:text-3xl font-heading font-bold text-text-secondary line-through opacity-60 mb-3" data-id="element-187">
                $85.00
              </p>
              <p className="text-urgency font-bold text-sm uppercase tracking-wider mb-2" data-id="element-188">
                Precio de Lanzamiento:
              </p>
            </div>

            <div className="flex items-center justify-center space-x-2 mb-3" data-id="element-189">
              <span className="text-5xl md:text-6xl font-heading font-extrabold text-cta-primary tracking-tight" data-id="element-190">
                $6.99
              </span>
              <span className="text-xl font-bold text-text-secondary self-end mb-2" data-id="element-191">
                USD
              </span>
            </div>

            <div className="inline-block bg-urgency/20 border border-urgency/40 rounded-full px-4 py-1 mb-2" data-id="element-192">
              <p className="text-urgency font-bold text-sm" data-id="element-193">
                ¡Ahorrás $78.01! (92% OFF)
              </p>
            </div>

            <p className="text-text-secondary uppercase tracking-wider text-xs font-medium" data-id="element-194">
              Pago Único - Sin Suscripciones
            </p>
          </div>

          {/* Includes */}
          <div className="bg-bg-primary/50 rounded-xl p-6 mb-8 border border-border-color" data-id="element-195">
            <p className="text-center text-text-primary font-bold mb-4" data-id="element-196">
              Incluye:
            </p>
            <ul className="space-y-3" data-id="element-197">
              {['Ebook El Método Magnético', '4 Bonos Exclusivos', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center space-x-3" data-id="element-198">
                  <Check className="w-5 h-5 text-cta-primary flex-shrink-0" data-id="element-199" />
                  <span className="text-text-normal" data-id="element-200">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Timer */}
          <div className="mb-8" data-id="element-201">
            <CountdownTimer data-id="element-202" />
          </div>

          {/* CTA */}
          <div className="space-y-4 text-center" data-id="element-203">
            <CTAButton href="https://pay.hotmart.com/D103645894Y?checkoutMode=10" fullWidth className="text-lg md:text-xl py-5" data-id="element-204">
              SÍ, QUIERO EL MÉTODO MAGNÉTICO
            </CTAButton>

            <div className="flex items-center justify-center space-x-3 text-xs text-text-secondary" data-id="element-205">
              <span className="flex items-center" data-id="element-206">
                <Lock className="w-3 h-3 mr-1" data-id="element-207" /> Pago seguro
              </span>
              <span className="w-1 h-1 bg-border-color rounded-full" data-id="element-208"></span>
              <span className="flex items-center" data-id="element-209">
                <Download className="w-3 h-3 mr-1" data-id="element-210" /> Descarga inmediata
              </span>
              <span className="w-1 h-1 bg-border-color rounded-full" data-id="element-211"></span>
              <span className="flex items-center" data-id="element-212">
                <ShieldCheck className="w-3 h-3 mr-1" data-id="element-213" /> Garantía 7 días
              </span>
            </div>
          </div>

          {/* Trust Footer */}
          <div className="mt-8 pt-6 border-t border-border-color grid grid-cols-1 gap-3 text-center text-sm text-text-secondary" data-id="element-214">
            <p data-id="element-215">Pago protegido</p>
            <p data-id="element-216">Acceso inmediato en tu correo</p>
            <p data-id="element-217">Compra 1 vez, úsalo siempre</p>
          </div>
        </motion.div>

        {/* Trust Badges Only */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-12" data-id="element-218">
          {/* Trust Seals */}
          <div className="text-center" data-id="element-219">
            <p className="text-xs text-text-secondary uppercase tracking-wider mb-6" data-id="element-220">
              Compra 100% segura
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6" data-id="element-221">
              {/* SSL Secure */}
              <div className="flex items-center space-x-2 bg-bg-card border border-border-color px-4 py-2 rounded-lg" data-id="element-222">
                <Lock className="w-5 h-5 text-cta-primary" data-id="element-223" />
                <div className="text-left" data-id="element-224">
                  <p className="text-xs font-bold text-text-primary" data-id="element-225">
                    SSL Seguro
                  </p>
                  <p className="text-[10px] text-text-secondary" data-id="element-226">
                    Encriptación 256-bit
                  </p>
                </div>
              </div>

              {/* Money Back */}
              <div className="flex items-center space-x-2 bg-bg-card border border-border-color px-4 py-2 rounded-lg" data-id="element-227">
                <ShieldCheck className="w-5 h-5 text-cta-primary" data-id="element-228" />
                <div className="text-left" data-id="element-229">
                  <p className="text-xs font-bold text-text-primary" data-id="element-230">
                    Garantía 7 días
                  </p>
                  <p className="text-[10px] text-text-secondary" data-id="element-231">
                    Reembolso total
                  </p>
                </div>
              </div>

              {/* Verified Purchase */}
              <div className="flex items-center space-x-2 bg-bg-card border border-border-color px-4 py-2 rounded-lg" data-id="element-232">
                <Check className="w-5 h-5 text-cta-primary" data-id="element-233" />
                <div className="text-left" data-id="element-234">
                  <p className="text-xs font-bold text-text-primary" data-id="element-235">
                    Compra Verificada
                  </p>
                  <p className="text-[10px] text-text-secondary" data-id="element-236">
                    Pago protegido
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}